// web/src/app/models/graduacion.model.ts
export class Graduacion {
  constructor(
    public id: number,
    public nombre: string,           // ✅ Changed from 'descripcion'
    public abreviatura?: string,     // ✅ New field
    public corto?: string,           // ✅ New field
    public dan?: number | null,      // ✅ New field
    public gup?: number | null       // ✅ New field
  ) {
    if (!id || !nombre) {
      throw new Error("id and nombre are required fields and cannot be null");
    }
  }

  // Keep descripcion as getter for backward compatibility
  get descripcion(): string {
    return this.nombre;
  }

  set descripcion(value: string) {
    this.nombre = value;
  }

  static fromRows(rows: any[]): Graduacion[] {
    return rows.map(row => new Graduacion(
      row.id,
      row.nombre,
      row.abreviatura,
      row.corto,
      row.dan,
      row.gup
    ));
  }

  static fromApiData(data: any): Graduacion {
    return new Graduacion(
      data.id,
      data.nombre,
      data.abreviatura,
      data.corto,
      data.dan,
      data.gup
    );
  }

  fill(newFields: Partial<Graduacion>): void {
    for (let field in newFields) {
      if (this.hasOwnProperty(field) && newFields.hasOwnProperty(field)) {
        const key = field as keyof Graduacion;
        if (this[key] !== undefined) {
          (this[key] as any) = newFields[key]!;
        }
      }
    }
  }

  // Helper methods
  isDan(): boolean {
    return this.dan !== null && this.dan !== undefined;
  }

  isGup(): boolean {
    return this.gup !== null && this.gup !== undefined;
  }

  getShortName(): string {
    return this.corto || this.abreviatura || this.nombre;
  }
}